import React, { FC } from 'react';
import * as ReactDOM from 'react-dom';
import PulseLoader from 'react-spinners/PulseLoader';
import styles from './Preloader.module.scss';

const Preloader: FC = () => {
  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <span className={styles.loader}></span>
    </div>,
    document.getElementById('portal') as HTMLElement
  );
};

export default Preloader;
